import React from 'react';

/** Floating circular + (shared by org web map edge and list view sticky corner). */
const GroupsFloatingAddBtn = ({
  onClick,
  ariaLabel = 'Add',
  title,
  className = '',
  onPointerDown
}) => (
  <button
    type="button"
    className={['groups-org-tree-add-group-btn', 'groups-org-floating-add-btn', className]
      .filter(Boolean)
      .join(' ')}
    onClick={onClick}
    onPointerDown={onPointerDown}
    aria-label={ariaLabel}
    title={title || ariaLabel}
  >
    <svg
      className="groups-org-tree-add-group-btn__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  </button>
);

export default GroupsFloatingAddBtn;
